import React from 'react';

interface TableRowProps {
  label: string;
  amount?: string | number;
  actionCell?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const TableRow: React.FC<TableRowProps> = React.memo(({
  label,
  amount,
  actionCell,
  className,
  style
}) => {
  return (
    <tr className={className} style={style}>
      <td>{label}</td>
      <td>{amount || ''}</td>
      <td>{actionCell || ''}</td>
    </tr>
  );
});

TableRow.displayName = 'TableRow';

export default TableRow;